import { Component } from '@angular/core';

import { ModalComponent } from '../../modal/modal.component';
import { BaseMenuComponent } from '../base.menu';
import { PeopleService } from '../../shared/services';

import { BasePluginMenuComponent } from './base.menu';
@Component({
    templateUrl: './observation.menu.html',
    standalone: false
})
export class ObservationMenuComponent extends BasePluginMenuComponent {}
